import { Box, FormControl, Grid, Typography } from "@mui/material";
import styles from "../reportSection.module.scss";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomCalendarTodayOutlinedIcon,
  CustomDatePicker,
  CustomMenuItem,
  CustomRequiredInputLabel,
  CustomSelectforFamily,
  StyledDateContainer,
} from "../../common/StyledComponents/StyledFields";
import { useState } from "react";
import { ValidationError, object, string } from "yup";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { apiRequest } from "../../../infrastructure/backendService";
import { CommentBankOutlined } from "@mui/icons-material";
import { ClipLoader } from "react-spinners";
import CustomDatePickerField from "../../CompactCustomComponents/CustomDatePickerField";

interface ErrorMessageTypesSearch {
  searchByDay: string;
  searchByWeekly: string;
  searchByMonthly: string;
  searchByQuarterly: string;
  selectYear: string;
  searchYear: string;
}
const formFieldsBookingSummary = {
  searchByDay: "",
  searchByWeekly: "",
  searchByMonthly: "",
  searchByQuarterly: "",
  selectYear: "",
  searchYear: "",
};
const styles_dropdown = {
    textField: {
      border: "1px solid rgba(136, 46, 20, 0.4)",
      backgroundColor: "#FFF9E4",
      borderRadius: "8px",
    },
    errorTextField: {
      border: "1px solid #f05802",
      borderRadius: "8px",
      width: "100%",
      backgroundColor: "#FFF9E4",
    },
  };
const PoojaBookingSummary = ({ sendDataToParent, getReportData }: any) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessageBookSummayry, setErrorMessageBookSummary] =
    useState<ErrorMessageTypesSearch>({ ...formFieldsBookingSummary });
  const [formDataBookPoojaSummary, setFormDataBookPoojaSummary] = useState(
    formFieldsBookingSummary
  );

  const [isDaySearch, setIsDaySearch] = useState(false);
  const [isWeekSearch, setIsWeekSearch] = useState(false);
  const [isMonthSearch, setIsMonthSearch] = useState(false);
  const [isQuarterlySearch, setIsQuarterlySearch] = useState(false);
  const [isFieldName, setIsFieldName] = useState("");

  const validationSchemaSignIn = object().shape({
    searchByDay: string().required("Search By Day is required"),
    //signInName: string().required('SignIn-Name is required'),
    searchByWeekly: string().required("Search By Weekly is required"),
    searchByQuarterly: string().required("Search By Quarterly is required"),
    selectYear: string().required("Select Year is required"),
    searchYear: string().required("Search Year is required"),
    searchByMonthly: string().required("Search By Monthly is required"),
  });

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const Quarterly = ["Jan-March", "April-June", "July-Sept", "Oct-Dec"];

  // const reqBody:any = {};

  const generateArrayOfYears = () => {
    let currentYear = new Date().getFullYear();
    var lastTenYears = currentYear - 10;
    var years = [];

    for (var i = currentYear; i >= lastTenYears; i--) {
      years.push(i);
    }
    return years;
  };

  const handleSearchByDateChange = (field: any, value: any) => {
    if (field === "searchByDay" || field === "searchByWeekly") {
      let formattedDate = dayjs(value, "MM/DD/YYYY");
      setFormDataBookPoojaSummary({
        ...formDataBookPoojaSummary,
        [field]: formattedDate.isValid()
          ? formattedDate.format("MM/DD/YYYY")
          : "",
      });
    } else {
      setFormDataBookPoojaSummary({
        ...formDataBookPoojaSummary,
        [field]: value,
      });
    }
    /* Enable and disable of fields accordingly */
    // if (field === "searchByDay") {
    //   setIsWeekSearch(true);
    //   setIsMonthSearch(true);
    //   setIsQuarterlySearch(true);
    // } else if (field === "searchByWeekly") {
    //   setIsDaySearch(true);
    //   setIsMonthSearch(true);
    //   setIsQuarterlySearch(true);
    // } else if (field === "searchByMonthly" || field === "selectYear") {
    //   setIsDaySearch(true);
    //   setIsWeekSearch(true);
    //   setIsQuarterlySearch(true);
    // } else if (field === "searchByQuarterly" || field === "searchYear") {
    //   setIsDaySearch(true);
    //   setIsWeekSearch(true);
    //   setIsMonthSearch(true);
    // }
    /* Enable and disable of fields accordingly */
    setIsFieldName(field);
  };

  const getPoojaBookingSummaryReports = () => {
    const valueSelected: any = Object.entries(formDataBookPoojaSummary).reduce(
      (a, [k, v]) => (v === "" ? a : (((a as any)[k] = v), a)),
      {}
    );
    let reqBody: any = {};
    if (isFieldName === "searchByDay") {
      reqBody.searchStartDate = valueSelected[isFieldName];
      reqBody.searchEndDate = valueSelected[isFieldName];
    } else if (isFieldName === "searchByWeekly") {
      reqBody.searchStartDate = valueSelected[isFieldName];
      reqBody.searchEndDate = dayjs(valueSelected[isFieldName], "MM/DD/YYYY")
        .add(1, "week")
        .format("MM/DD/YYYY");
    } else if (
      isFieldName === "searchByMonthly" ||
      isFieldName === "selectYear"
    ) {
      let monthStartDate = dayjs(
        new Date(valueSelected["selectYear"], valueSelected["searchByMonthly"])
      ).format("MM/DD/YYYY");
      let monthEndDate = dayjs(
        new Date(
          valueSelected["selectYear"],
          valueSelected["searchByMonthly"] + 1,
          0
        )
      ).format("MM/DD/YYYY");
      reqBody.searchStartDate = monthStartDate;
      reqBody.searchEndDate = monthEndDate;
    } else if (
      isFieldName === "searchByQuarterly" ||
      isFieldName === "searchYear"
    ) {
      let quarterStartDate = dayjs(
        new Date(
          valueSelected["searchYear"],
          valueSelected["searchByQuarterly"]
        )
      ).format("MM/DD/YYYY");
      let quarterEndDate = dayjs(
        new Date(
          valueSelected["searchYear"],
          valueSelected["searchByQuarterly"] + 3,
          0
        )
      ).format("MM/DD/YYYY");
      reqBody.searchStartDate = quarterStartDate;
      reqBody.searchEndDate = quarterEndDate;
    }
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: "/report-dashboard/reports/pooja/POOJA_BOOKING_SUMMARY/browser",
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        setLoading(false);
        sendDataToParent(true, reqBody);
        const response = res?.data?.map((obj: any) => {
          return {
            "Name (Sign-in)": `${obj.firstname} ${obj.middlename} ${obj.lastname} (${obj.username})`,
            "Temple Poojas": obj.templeTotal,
            "Outside Poojas": obj.outsideTotal,
            "Priest Duties": obj.priestDutiesTotal,
          };
        });
        getReportData(response);
        setIsDaySearch(false);
        setIsWeekSearch(false);
        setIsMonthSearch(false);
        setIsQuarterlySearch(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handlSubmitSummary = async () => {
    const errors: ErrorMessageTypesSearch = {
      ...formFieldsBookingSummary,
    };
    try {
      // Validate the form data against the validation schema
      //    await validationSchemaSignIn.validate(formDataBookPoojaSummary, { abortEarly: false });
      // If validation passes, you can submit the form
      //    setErrorMessageBookSummary(errors);
      // Call your API or perform other actions here
      // saveApiCall();
      getPoojaBookingSummaryReports();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypesSearch] = e.message;
          }
        });
      }
      setErrorMessageBookSummary(errors);
    }
  };

  const handleClear = () => {
    setFormDataBookPoojaSummary(formFieldsBookingSummary);
  };

  const SearchByDayDateofPicker = (): React.ReactElement => {
    return (
      <CustomDatePickerField
        date={formDataBookPoojaSummary.searchByDay}
        handleDateChange={handleSearchByDateChange}
        errorMessage={undefined}
        name="searchByDay"
        format="MM-DD-YYYY"
        disableFuture
      />
    );
  };



  const SerachByWeeklyDatePicker = (): React.ReactElement => {
    return (
      <CustomDatePickerField
        date={formDataBookPoojaSummary.searchByWeekly}
        handleDateChange={handleSearchByDateChange}
        errorMessage={undefined}
        name="searchByWeekly"
        format="MM-DD-YYYY"
        disableFuture
      />
    );
  };

  const SelectMonthDropdown = (): React.ReactElement => {
    return (
      <>
        <FormControl sx={{width:"100%"}}>
          <CustomSelectforFamily
            IconComponent={KeyboardArrowDownIcon}
            defaultValue=""
            id="grouped-select"
            disabled={isMonthSearch}
            value={formDataBookPoojaSummary.searchByMonthly}
            onChange={(e) => {
              handleSearchByDateChange("searchByMonthly", e.target.value);
              setErrorMessageBookSummary({
                ...errorMessageBookSummayry,
                searchByMonthly: "",
              });
            }}

            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1px solid #F05802",
                  "& ul": {
                    paddingTop: 0,
                    paddingBottom: 0,
                    overflowY: "auto",
                    minHeight: "auto",
                    maxHeight: "300px",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#F3C539",
                      borderRadius: "6px",
                    },
                  },
                },
              },
            }}
            sx={[
                {...styles_dropdown.textField, backgroundColor:'#fff'},
                {
                  "& .MuiSelect-outlined": {
                    opacity: 1,
                    p: "8px",
                    fontSize: "14px",
                    fontFamily: "Lato",
                    backgroundColor:'#fff'
                  },
                },
              ]}
          >
            {months.map((month: any, index: any) => (
              <CustomMenuItem value={index} key={index}>
                {month}
              </CustomMenuItem>
            ))}
          </CustomSelectforFamily>
        </FormControl>
        {errorMessageBookSummayry.searchByMonthly && (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessageBookSummayry.searchByMonthly}
          </Typography>
        )}
      </>
    );
  };
  const SearchByQuarterlyDropdown = (): React.ReactElement => {
    return (
      <>
        <FormControl sx={{width:"100%"}}>
          <CustomSelectforFamily
            IconComponent={KeyboardArrowDownIcon}
            defaultValue=""
            id="grouped-select"
            disabled={isQuarterlySearch}
            value={formDataBookPoojaSummary.searchByQuarterly}
            onChange={(e) => {
              handleSearchByDateChange("searchByQuarterly", e.target.value);
              setErrorMessageBookSummary({
                ...errorMessageBookSummayry,
                searchByQuarterly: "",
              });
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1px solid #F05802",
                  "& ul": {
                    paddingTop: 0,
                    paddingBottom: 0,
                    overflowY: "auto",
                    minHeight: "auto",
                    maxHeight: "300px",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#F3C539",
                      borderRadius: "6px",
                    },
                  },
                },
              },
            }}
            sx={[
                {...styles_dropdown.textField, backgroundColor:'#fff'},
                {
                  "& .MuiSelect-outlined": {
                    opacity: 1,
                    p: "8px",
                    fontSize: "14px",
                    fontFamily: "Lato",
                    backgroundColor:'#fff'
                  },
                },
              ]}
          >
            {Quarterly.map((quarter: any, index: any) => (
              <CustomMenuItem value={index * 3} key={index}>
                {quarter}
              </CustomMenuItem>
            ))}
          </CustomSelectforFamily>
        </FormControl>
        {errorMessageBookSummayry.searchByQuarterly && (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessageBookSummayry.searchByQuarterly}
          </Typography>
        )}
      </>
    );
  };
  const SelectByYearDropdown = (): React.ReactElement => {
    return (
      <>
        <FormControl sx={{width:"100%"}}>
          <CustomSelectforFamily
            IconComponent={KeyboardArrowDownIcon}
            defaultValue=""
            id="grouped-select"
            disabled={isMonthSearch}
            value={formDataBookPoojaSummary.selectYear}
            onChange={(e) => {
              handleSearchByDateChange("selectYear", e.target.value);
              setErrorMessageBookSummary({
                ...errorMessageBookSummayry,
                selectYear: "",
              });
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1px solid #F05802",
                  "& ul": {
                    paddingTop: 0,
                    paddingBottom: 0,
                    overflowY: "auto",
                    minHeight: "auto",
                    maxHeight: "300px",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#F3C539",
                      borderRadius: "6px",
                    },
                  },
                },
              },
            }}
            sx={[
                {...styles_dropdown.textField, backgroundColor:'#fff'},
                {
                  "& .MuiSelect-outlined": {
                    opacity: 1,
                    p: "8px",
                    fontSize: "14px",
                    fontFamily: "Lato",
                    backgroundColor:'#fff'
                  },
                },
              ]}
          >
            {generateArrayOfYears().map((year: any) => (
              <CustomMenuItem value={year} key={year}>
                {year}
              </CustomMenuItem>
            ))}
          </CustomSelectforFamily>
        </FormControl>
        {errorMessageBookSummayry.selectYear && (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessageBookSummayry.selectYear}
          </Typography>
        )}
      </>
    );
  };
  const SearchByYear = (): React.ReactElement => {
    return (
      <>
        <FormControl sx={{width:"100%"}}>
          <CustomSelectforFamily
            IconComponent={KeyboardArrowDownIcon}
            defaultValue=""
            id="grouped-select"
            disabled={isQuarterlySearch}
            value={formDataBookPoojaSummary.searchYear}
            onChange={(e) => {
              handleSearchByDateChange("searchYear", e.target.value);
              setErrorMessageBookSummary({
                ...errorMessageBookSummayry,
                searchYear: "",
              });
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1px solid #F05802",
                  "& ul": {
                    paddingTop: 0,
                    paddingBottom: 0,
                    overflowY: "auto",
                    minHeight: "auto",
                    maxHeight: "300px",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#F3C539",
                      borderRadius: "6px",
                    },
                  },
                },
              },
            }}
            sx={[
                {...styles_dropdown.textField, backgroundColor:'#fff'},
                {
                  "& .MuiSelect-outlined": {
                    opacity: 1,
                    p: "8px",
                    fontSize: "14px",
                    fontFamily: "Lato",
                    backgroundColor:'#fff'
                  },
                },
              ]}
          >
            {generateArrayOfYears().map((year: any) => (
              <CustomMenuItem value={year} key={year}>
                {year}
              </CustomMenuItem>
            ))}
          </CustomSelectforFamily>
        </FormControl>
        {errorMessageBookSummayry.searchYear && (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessageBookSummayry.searchYear}
          </Typography>
        )}
      </>
    );
  };
  return (
    <Box sx={{maxWidth:"450px"}}>
      <Grid container spacing={2} sx={{ mt: 0 }}>
        <Grid item xs={12} sm={6}>
          {CustomRequiredInputLabel("Search By Day", false)}
          {SearchByDayDateofPicker()}
        </Grid>
        <Grid item xs={12} sm={6}>
          {CustomRequiredInputLabel("Search By Weekly", false)}
          {SerachByWeeklyDatePicker()}
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ marginTop: "0px" }}>
        <Grid item xs={12} sm={6}>
          {CustomRequiredInputLabel("Search By Monthly", false)}
          {SelectMonthDropdown()}
        </Grid>
        <Grid item xs={12} sm={6}>
          {CustomRequiredInputLabel("Select By Year", false)}
          {SelectByYearDropdown()}
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ marginTop: "0px" }}>
        <Grid item xs={12} sm={6}>
          {CustomRequiredInputLabel("Search By Quarterly", false)}
          {SearchByQuarterlyDropdown()}
        </Grid>
        <Grid item xs={12} sm={6}>
          {CustomRequiredInputLabel("Search By Year", false)}
          {SearchByYear()}
        </Grid>
      </Grid>
      <Grid sx={{ mt: 3, display: "flex", gap: "16px" }}>
        <CommonButton
          sx={{ width: "fit-content", height: "38px" }}
          onClick={handlSubmitSummary}
          disabled={loading}
          id="submit"
        >
          {loading ? (
            <>
              <ClipLoader color="#fff" loading={loading} size={15} />
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                Submitting...
              </span>
            </>
          ) : (
            "Submit"
          )}
        </CommonButton>
        <CommonOutlinedButton onClick={handleClear}>Reset</CommonOutlinedButton>
      </Grid>
    </Box>
  );
};
export default PoojaBookingSummary;
